<template>
  <el-dialog
    :title="isEdit ? '编辑用户' : '新增用户'"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="formRules"
      label-width="80px"
    >
      <el-form-item label="用户名" prop="username">
        <el-input v-model="form.username" placeholder="请输入用户名" :disabled="isEdit" />
      </el-form-item>
      <el-form-item v-if="!isEdit" label="密码" prop="password">
        <el-input
          v-model="form.password"
          type="password"
          placeholder="请输入密码"
          show-password
        />
      </el-form-item>
      <el-form-item v-if="!isEdit" label="确认密码" prop="passwordConfirm">
        <el-input
          v-model="form.passwordConfirm"
          type="password"
          placeholder="请再次输入密码"
          show-password
        />
      </el-form-item>
      <el-form-item label="真实姓名" prop="realName">
        <el-input v-model="form.realName" placeholder="请输入真实姓名" />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="角色" prop="roleIds">
        <el-select v-model="form.roleIds" multiple placeholder="请选择角色" style="width: 100%">
          <el-option
            v-for="item in roleOptions"
            :key="item.id"
            :label="item.roleName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addUser, updateUser } from '@/api/user'
import { getRoleList } from '@/api/role'

export default {
  name: 'UserForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submitLoading: false,
      roleOptions: [],
      form: this.getDefaultForm()
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    isEdit() {
      return this.formData && this.formData.id
    },
    formRules() {
      const rules = {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        roleIds: [{ required: true, message: '请选择角色', trigger: 'change' }]
      }
      if (!this.isEdit) {
        rules.password = [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
        rules.passwordConfirm = [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入的密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
      return rules
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        await this.getRoleOptions()
        if (this.formData) {
          this.form = { ...this.formData }
          // 兼容 roleIds 可能是字符串的情况
          if (typeof this.form.roleIds === 'string') {
            try {
              this.form.roleIds = JSON.parse(this.form.roleIds)
            } catch (e) {
              this.form.roleIds = []
            }
          }
          if (!this.form.roleIds) {
            this.form.roleIds = []
          }
        } else {
          this.form = this.getDefaultForm()
        }
        // 数据回填后清除校验状态，避免显示错误提示
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate()
        })
      }
    }
  },
  methods: {
    getDefaultForm() {
      return {
        username: '',
        password: '',
        passwordConfirm: '',
        realName: '',
        phone: '',
        roleIds: [],
        status: 1
      }
    },

    // 获取角色选项
    getRoleOptions() {
      return getRoleList({ pageNum: 1, pageSize: 100 }).then(res => {
        const data = res.data
        this.roleOptions = Array.isArray(data) ? data : (data.records || data.list || [])
      })
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const api = this.isEdit ? updateUser : addUser
        api(this.form).then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.$emit('success')
        }).catch(() => {}).finally(() => {
          this.submitLoading = false
        })
      })
    },

    // 关闭弹窗
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.form = this.getDefaultForm()
    }
  }
}
</script>
